interface SourceProps {
  sourceName: string;
  style?: React.CSSProperties;
}
export const SourceReference: React.FC<SourceProps> = ({
  sourceName,
  style,
}) => (
  <div
    style={{
      fontSize: '14px',
      color: 'var(--darkGray)',
      textAlign: 'right',
      ...style,
    }}
  >
    Källa: {sourceName}
  </div>
);
